import * as Request from '../Request';

const Product = {
  // 系统列表
  list: (data) => {
    return Request.post('/product/list', data);
  },
  // 上传系统logo
  uploadLogo: (data) => {
    return Request.post('/product/logo/upload', data);
  },
  // 新增系统
  save: (data) => {
    return Request.post('/product/save', data);
  },
  // 列表项详情
  info: (data) => {
    return Request.get('/product/info', data);
  },
  // 更新系统
  update: (data) => {
    return Request.put('/product/update', data);
  },
  // 删除系统
  deleteSystem: (data) => {
    return Request.delBody('/product/delete', data)
  }
}
export default Product
